import { RouteConfig } from 'vue-router'

const Index = () => import('@/views/long-break/index.vue')
const List = () => import('@/views/long-break/List.vue')
const Detail = () => import('@/views/long-break/Detail.vue')
const Edit = () => import('@/views/long-break/Edit.vue')
const MovePracticeDetail = () => import('@/views/move-practice/Detail.vue')

const index: RouteConfig = {
  path: '/long-break',
  name: 'long_break',
  component: Index,
  meta: {
    title: '大课间',
    ignoreLogin: true,
  },
}

const listRoute: RouteConfig = {
  path: '/long-break-list',
  name: 'long_break_list',
  component: List,
  meta: {
    title: '练习任务',
  },
}

export const templateDetailRoute: RouteConfig = {
  path: '/long-break-detail',
  name: 'long_break_detail',
  component: Detail,
  props: (route) => ({ id: route.query.id }),
  meta: {
    title: '大课间详情',
    ignoreLogin: true,
  },
}

export const detailInfoRoute = {
  path: 'info',
  name: 'long_break_detail_info',
  component: () => import('@/views/move-practice/components/DetailInfo.vue'),
}

const detailRoute: RouteConfig = {
  path: '/long-break-detail',
  component: MovePracticeDetail,
  children: [
    detailInfoRoute,
    {
      path: 'stat',
      name: 'long_break_detail_stat',
      component: () => import('@/views/move-practice/components/DetailStat.vue'),
    },
  ],
  meta: {
    title: '练习详情页',
  },
}

export const editRoute: RouteConfig = {
  path: '/long-break-editer',
  name: 'long_break_editer',
  component: Edit,
  meta: {
    title: '编辑大课间',
  },
}

export default [index, listRoute, templateDetailRoute, detailRoute, editRoute]
